import * as React from "react";
import Icon from "../Icon";
import styles from "./styles.scss";

const handleClick = (): void => {
  window.print();
};

const PrintButton: React.FC<Record<string, unknown>> = () => {
  return (
    <button className={styles.root} onClick={handleClick}>
      <Icon name="icon-printer" className={styles.icon} />
    </button>
  );
};

export default PrintButton;
